var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-promotion"},[_c('PromotionInfo'),_c('BonusCardSteps'),_c('PromotionFaq')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }